export default __webpack_public_path__ + "static/media/right-arrow.5b457689.svg";